<img [attr.src]="value" alt="image" aria-label="image" />
